module.exports = __webpack_public_path__ + "img/aoste.063e9c59.jpg";